import { ReactImageGalleryItem } from 'react-image-gallery';

import { ChevronLeft, ChevronRight, CloseIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import ImageWithFallback from '@components/utils/ImageWithFallback';

import { CurrentSlideInfoDesktop } from '../GalleryStyles';
import {
  FullScreenWrapper,
  FullScreenContent,
  FullScreenLabel,
  FullScreenTotalItems,
  FullScreenGalleryTitle,
  ExistFullScreen,
  SlideLeftWrapper,
  SlideRightWrapper,
  CustomSlideButton,
  StyledImage,
} from './styled';

interface FullScreenGalleryProps {
  item: ReactImageGalleryItem;
  title: string;
  displayName?: string;
  totalItemsInfo?: string;
  hasItems: boolean;
}

interface FullScreenGalleryControlsProps {
  existFullScreen: () => void;
  nextSlide: () => void;
  previousSlide: () => void;
}

export const FullScreenGalleryControls = ({
  existFullScreen,
  previousSlide,
  nextSlide,
}: FullScreenGalleryControlsProps) => {
  return (
    <>
      <ExistFullScreen onClick={existFullScreen}>
        <CustomIcon icon={CloseIcon} fontSize={16} paletteColor='darkGrey' />
      </ExistFullScreen>

      <SlideLeftWrapper>
        <CustomSlideButton onClick={previousSlide}>
          <ChevronLeft />
        </CustomSlideButton>
      </SlideLeftWrapper>

      <SlideRightWrapper>
        <CustomSlideButton onClick={nextSlide}>
          <ChevronRight />
        </CustomSlideButton>
      </SlideRightWrapper>
    </>
  );
};

const FullScreenGallery = ({
  item,
  title,
  displayName,
  totalItemsInfo,
  hasItems,
}: FullScreenGalleryProps) => {
  return (
    <FullScreenWrapper>
      <FullScreenContent>
        <FullScreenGalleryTitle>{title}</FullScreenGalleryTitle>
        <FullScreenTotalItems>
          {hasItems && displayName ? (
            <CurrentSlideInfoDesktop>
              <span>{displayName}</span>
              <span>{totalItemsInfo}</span>
            </CurrentSlideInfoDesktop>
          ) : null}
        </FullScreenTotalItems>

        <ImageWithFallback
          Component={StyledImage}
          src={item.original}
          alt={item.originalAlt ?? 'setur'}
          fill
        />
        <FullScreenLabel>{item?.description}</FullScreenLabel>
      </FullScreenContent>
    </FullScreenWrapper>
  );
};

export default FullScreenGallery;
